export const PADDING = '15%';
